function getDefaultState() {
    return {
      items: []
    };
  }
  
  const state = getDefaultState();
  
  const getters = {
    getItems(state) {
        return state.items;
    },
    getItensCarrinhoZero () {
      return state.items.filter(item => item.carrinho === 0)
    }
  };
  
  const mutations = {
    setItems(state, items) {
        state.items = items;
      }
  };
  
  const actions = {
    setItems: ({commit}, items) => {
        commit('setItems', items);
    }
  };
  
  export default { namespaced: true, state, mutations, getters, actions };
    